import { DropdownButton, MenuItem } from 'react-bootstrap';
import type * as React from 'react';
import type { SelectCallback } from 'react-bootstrap';

import { icons, IconText } from '../../../generic';
import type { Repository } from '../../../../types';

import type { OnBranchChangeFn } from './types';

import styles from './BranchDropdown.module.less';

type BranchDropdownProps = {
  repo: Repository;
  onBranchChange: OnBranchChangeFn;
  isDisabled?: boolean;
};

const BranchDropdown = (props: BranchDropdownProps) => {
  const changeBranch = (branch: string, event: React.SyntheticEvent<object>) => {
    event.stopPropagation();
    event.preventDefault();
    props.onBranchChange(props.repo, branch);
  };

  const menuItems = props.repo.branches?.map((branch) => (
    <MenuItem eventKey={branch} key={branch}>
      {branch}
    </MenuItem>
  ));
  return (
    <span className={styles.branchDropdown}>
      <DropdownButton
        className={styles.dropdownButton}
        id="serviceImportDropdownButton"
        onSelect={changeBranch as SelectCallback}
        onClick={(e) => {
          // Prevent the event's default so that the parent table row can
          // notice and avoid selecting the repository.
          e.preventDefault();
        }}
        title={<IconText icon={icons.codeBranch} text={props.repo?.branch || ''} marginAmount="8px" />}
        disabled={props.isDisabled}
        pullRight>
        {menuItems}
      </DropdownButton>
    </span>
  );
};

export default BranchDropdown;
